module.exports = __webpack_public_path__ + "static/shibon-cover-7dfade88155721a8c4bd5436f9561de6.png";